export default __webpack_public_path__ + "static/media/coinRm.8cfeff92.svg";